import React from 'react';

import PropTypes from 'prop-types';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import { useTranslation } from 'react-i18next';

import partner1 from '../../Assets/img/partner_1.webp';
import partner2 from '../../Assets/img/partner_2.webp';
import partner3 from '../../Assets/img/partner_3.webp';
import partner4 from '../../Assets/img/partner_4.webp';
import partner5 from '../../Assets/img/partner_5.webp';
import partner6 from '../../Assets/img/partner_6.webp';
import partner7 from '../../Assets/img/partner_7.webp';
import partner8 from '../../Assets/img/partner_8.webp';
import partner9 from '../../Assets/img/partner_9.webp';
import WithBackground from '../Common/WithBackground';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import './style.css';

const EmployerPartners = ({ bg, overlay }) => {
  const { t } = useTranslation();

  const partnersData = [
    {
      id: 1,
      logo: partner1,
      name: t('partners.partnerData.idLogistics.name'),
      description: t('partners.partnerData.idLogistics.description'),
    },
    {
      id: 2,
      logo: partner2,
      name: t('partners.partnerData.fourPx.name'),
      description: t('partners.partnerData.fourPx.description'),
    },
    {
      id: 3,
      logo: partner3,
      name: t('partners.partnerData.goremPrefa.name'),
      description: t('partners.partnerData.goremPrefa.description'),
    },
    {
      id: 4,
      logo: partner4,
      name: t('partners.partnerData.polskieRury.name'),
      description: t('partners.partnerData.polskieRury.description'),
    },
    {
      id: 5,
      logo: partner5,
      name: t('partners.partnerData.formee.name'),
      description: t('partners.partnerData.formee.description'),
    },
    {
      id: 6,
      logo: partner6,
      name: t('partners.partnerData.unipako.name'),
      description: t('partners.partnerData.unipako.description'),
    },
    {
      id: 7,
      logo: partner7,
      name: t('partners.partnerData.hankeTissue.name'),
      description: t('partners.partnerData.hankeTissue.description'),
    },
    {
      id: 8,
      logo: partner8,
      name: t('partners.partnerData.kohlGroup.name'),
      description: t('partners.partnerData.kohlGroup.description'),
    },
    {
      id: 9,
      logo: partner9,
      name: t('partners.partnerData.converis.name'),
      description: t('partners.partnerData.converis.description'),
    },
    {
      id: 10,
      logo: null,
      name: t('partners.partnerData.mcdonalds.name'),
      description: t('partners.partnerData.mcdonalds.description'),
    },
  ];

  const partnersContent = (
    <section className='employer-partners' id='partners'>
      <div className='employer-partners__container'>
        <div className='employer-partners__header'>
          <h2 className='employer-partners__title'>{t('partners.title')}</h2>
          <p className='employer-partners__intro'>{t('partners.subtitle')}</p>
        </div>

        <div className='partners-swiper-container'>
          <Swiper
            modules={[Navigation, Pagination, Autoplay]}
            spaceBetween={32}
            slidesPerView={1}
            navigation={{
              prevEl: '.partners-swiper__prev',
              nextEl: '.partners-swiper__next',
            }}
            pagination={{
              el: '.partners-swiper__pagination',
              clickable: true,
            }}
            autoplay={{
              delay: 4000,
              disableOnInteraction: false,
            }}
            breakpoints={{
              640: {
                slidesPerView: 2,
                spaceBetween: 24,
              },
              768: {
                slidesPerView: 2,
                spaceBetween: 24,
              },
              1024: {
                slidesPerView: 3,
                spaceBetween: 32,
              },
            }}
            className='partners-swiper'
          >
            {partnersData.map((partner) => (
              <SwiperSlide key={partner.id}>
                <div className='partner-card'>
                  {partner.logo ? (
                    <div className='partner-card__logo'>
                      <img
                        src={partner.logo}
                        alt={partner.name}
                        className='partner-card__logo-image'
                      />
                    </div>
                  ) : (
                    <div className='partner-card__logo partner-card__logo--text'>
                      <span className='partner-card__logo-text'>
                        {partner.name}
                      </span>
                    </div>
                  )}

                  <h3 className='partner-card__name'>{partner.name}</h3>

                  <p className='partner-card__description'>
                    {partner.description}
                  </p>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          <div className='partners-swiper__navigation'>
            <button className='partners-swiper__prev' aria-label='Previous'>
              <svg width='20' height='20' viewBox='0 0 24 24' fill='none'>
                <path
                  d='M15 18L9 12L15 6'
                  stroke='currentColor'
                  strokeWidth='2'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
              </svg>
            </button>

            <button className='partners-swiper__next' aria-label='Next'>
              <svg width='20' height='20' viewBox='0 0 24 24' fill='none'>
                <path
                  d='M9 18L15 12L9 6'
                  stroke='currentColor'
                  strokeWidth='2'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
              </svg>
            </button>
          </div>

          <div className='partners-swiper__pagination'></div>
        </div>

        <div className='employer-partners__cta'>
          <div className='partners-cta'>
            <h3 className='partners-cta__title'>{t('partners.cta.title')}</h3>
            <p className='partners-cta__subtitle'>
              {t('partners.cta.subtitle')}
            </p>
          </div>
        </div>
      </div>
    </section>
  );

  return bg ? (
    <WithBackground bg={bg} overlay={overlay}>
      {partnersContent}
    </WithBackground>
  ) : (
    partnersContent
  );
};

EmployerPartners.propTypes = {
  bg: PropTypes.string,
  overlay: PropTypes.oneOf(['dark', 'light', 'golden', 'none']),
};

EmployerPartners.defaultProps = {
  bg: null,
  overlay: 'dark',
};

export default EmployerPartners;
